import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";


interface iCustomToolbar {
    dialogState: (param:boolean) => void;
}


const CustomToolbar = (
    props : iCustomToolbar
) => {


    // const closeDialog = () => {
    //     props.dialogState(false );
    //
    // };

    const handleInsertClick = () => {
        props.dialogState(true);
    };


    return (
        <React.Fragment>
            <Tooltip title={"icon 1"}>
                <IconButton onClick={handleInsertClick} size="large">
                    <AddCircleIcon  />
                </IconButton>
            </Tooltip>
        </React.Fragment>
    );
}

export default CustomToolbar;
